import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="border-t border-soft bg-room">
      <div className="access-container py-14">
        <div className="flex flex-col md:flex-row gap-10 md:gap-6 md:items-center md:justify-between">
          <div>
            <div className="flex items-center gap-3">
              <span className="w-7 h-7 rounded-full border border-gold flex items-center justify-center font-display text-gold text-[13px]" style={{ fontVariationSettings: '"opsz" 48, "SOFT" 30', fontWeight: 500 }}>C</span>
              <span className="font-mono text-bone text-[11px] tracking-[0.22em] uppercase">Closer Academy</span>
            </div>
            <p className="mt-3 text-dim text-sm">Sales is the skill that opens doors.</p>
          </div>
          <nav className="flex flex-wrap gap-x-6 gap-y-2 font-mono text-[11px] tracking-[0.22em] uppercase text-dim">
            <Link to="/legal/terms" className="hover:text-bone">Terms</Link>
            <Link to="/legal/privacy" className="hover:text-bone">Privacy</Link>
            <a href="mailto:hello@thecloseracademy.org" className="hover:text-bone">Contact</a>
          </nav>
        </div>
        <div className="my-10 h-px bg-gradient-to-r from-transparent via-gold/30 to-transparent" />
        <p className="text-mute text-xs leading-relaxed max-w-3xl">
          © 2026 Closer Academy. Results vary. Closer Academy does not guarantee income, revenue, sales results, business growth, or any specific outcome. Results depend on effort, skill, market conditions, offer, timing, and execution.
        </p>
      </div>
    </footer>
  );
}
